const API_LANGUAGE_MODAL_LOAD_LIST_URL = '/language/default/load-list';

const API_LANGUAGE_MODAL_NAME = 'apiLanguageModal';

export {
  API_LANGUAGE_MODAL_LOAD_LIST_URL,

  API_LANGUAGE_MODAL_NAME,
};
